import React from 'react';
import { SubmitError } from 'Components/Fields/SubmitError';
import { asyncValidateExistingUser, email, password, requiredEmail, requiredPassword } from 'Utils/FormValidation';
import { getPageSourceMLP } from 'Utils/Analytics/Segment';
import './CreateAccountForm.css';
import { TosAndPrivacyFinePrint } from 'Components/FinePrint';
import { SubmitButton } from 'Components/Fields/Buttons';
import { useForm } from 'Hooks/useForm';
import { FormField } from 'Components/HookFormFields/FormField';

const CreateAccountForm = ({ onFormSubmit, submitButtonText, pageStartSource }) => {
  const formName = 'createAccountForm';
  const { formFieldProps, submitting, submitDisabled, formError, handleSubmit } = useForm({
    onFormSubmit,
    formName,
    pageStartSource: getPageSourceMLP() || pageStartSource,
  });

  return (
    <form onSubmit={(event) => handleSubmit(event)} className={formName}>
      <section className="formInput">
        <FormField
          name="email"
          label="Email Address"
          component="EmailField"
          validate={[requiredEmail, email]}
          validateDebounceTime={600}
          asyncValidate={[asyncValidateExistingUser]}
          formName={formName}
          {...formFieldProps}
        />
        <FormField
          name="password"
          label="Password (6 character min)"
          component="PasswordField"
          validate={[requiredPassword, password]}
          validateOnBlur={[password]}
          validateDebounceTime={600}
          warn
          {...formFieldProps}
        />
      </section>
      <SubmitError error={formError} formName={formName} />
      <TosAndPrivacyFinePrint ctaText={submitButtonText} />
      <SubmitButton text={submitButtonText} submitting={submitting} isDisabled={submitDisabled} modernLayout />
    </form>
  );
};

export default CreateAccountForm;
